import { SPIEROPBOUW_SCHEMAS } from "./schemaDataSpieropbouw";
import { ONDERHOUD_SCHEMAS } from "./schemaDataOnderhoud";
import { POWERLIFTING_SCHEMAS } from "./schemaDataPowerlifting";

// ─── HELPERS ──────────────────────────────────────────────────────────────────
const ex = (code, naam, sets_reps, tempo, rust, notitie) => ({
  code, naam, sets_reps, tempo, rust, superset: null, notitie,
});

// Beginner: 3×15, 2020
const b = (code, naam, notitie, rust = "90 sec") =>
  ex(code, naam, "3 × 15", "2020", rust, notitie);

// Gevorderd standaard (eerste 4): 3×10, 3010
const gS = (code, naam, notitie, rust = "90 sec") =>
  ex(code, naam, "3 × 10", "3010", rust, notitie);

// Gevorderd laatste 2: 3×12, 3010
const gL = (code, naam, notitie, rust = "60 sec") =>
  ex(code, naam, "3 × 12", "3010", rust, notitie);

// Advanced eerste 4: 4×6, 3110
const aS = (code, naam, notitie, rust = "120 sec") =>
  ex(code, naam, "4 × 6", "3110", rust, notitie);

// Advanced laatste 2: 4×12, 3110
const aL = (code, naam, notitie, rust = "60 sec") =>
  ex(code, naam, "4 × 12", "3110", rust, notitie);

// ─── VETVERLIES — BEGINNER ────────────────────────────────────────────────────

const vt_fullBodyA_beginner = {
  id: "A", naam: "Sessie A – Full Body",
  exercises: [
    b("A1", "Squat (High Bar)",                 "Voeten op schouderbreedte. Knieën volgen de richting van de tenen. Zak tot parallel.", "90 sec"),
    b("A2", "Bench Press",                       "Schouderbladen samen, voeten plat op de grond. Stang daalt gecontroleerd naar de borst.", "90 sec"),
    b("A3", "Romanian Deadlift (Barbell)",       "Heupen schuiven naar achteren. Rug recht. Stang blijft dicht langs de benen.", "90 sec"),
    b("A4", "Lat Pulldown (Breed Grip)",         "Licht achteroverleunen. Trek de stang richting de sleutelbeenderen. Ellebogen omlaag.", "90 sec"),
    b("A5", "Dumbbell Curl (Staand)",            "Ellebogen gefixeerd langs het lichaam. Supineer de pols bovenin de beweging.", "60 sec"),
    b("A6", "Tricep Pushdown (Touw)",            "Ellebogen naast het lichaam. Trek het touw uiteen onderaan voor maximale samentrekking.", "60 sec"),
  ],
};

const vt_fullBodyB_beginner = {
  id: "B", naam: "Sessie B – Full Body",
  exercises: [
    b("A1", "Leg Press",                         "Voeten schouderbreedte op het platform. Knieën niet volledig strekken bovenaan.", "90 sec"),
    b("A2", "Incline Dumbbell Press",            "Bank op 30–45°. Dumbbells starten naast de borst. Druk omhoog en iets naar elkaar.", "90 sec"),
    b("A3", "Leg Curl (Liggend)",                "Buikligging. Hiel naar bil trekken. Langzaam terugzakken in 2 seconden.", "90 sec"),
    b("A4", "Seated Cable Row (Smal Grip)",      "Zit rechtop. Trek naar de navel. Schouderbladen maximaal samentrekken.", "90 sec"),
    b("A5", "Hammer Curl",                       "Neutrale greep (duimen omhoog). Treft ook de brachialis. Ellebogen stabiel.", "60 sec"),
    b("A6", "Tricep Pushdown (Rechte Stang)",    "Overhandse greep. Strek volledig aan de onderkant. Ellebogen naast het lichaam.", "60 sec"),
  ],
};

const vt_upper_beginner = {
  id: "A", naam: "Sessie A – Upper Body",
  exercises: [
    b("A1", "Bench Press",                       "Schouderbladen samen. Stang daalt gecontroleerd naar de onderkant van de borst.", "90 sec"),
    b("A2", "Lat Pulldown (Breed Grip)",         "Trek naar de sleutelbeenderen. Ellebogen omlaag en naar achteren.", "90 sec"),
    b("A3", "Incline Dumbbell Press",            "Bank op 30–45°. Focus op de bovenste borst. Gecontroleerde neerwaartse fase.", "90 sec"),
    b("A4", "Seated Cable Row (Smal Grip)",      "Rug rechtop. Schouderbladen volledig samentrekken aan het einde.", "90 sec"),
    b("A5", "Cable Fly (Low to High)",           "Kabels laag instellen. Beweging van onder naar boven en samen. Focus op bovenborst.", "60 sec"),
    b("A6", "Face Pull",                         "Kabel op ooghoogte. Trek naar gezicht met hoge ellebogen. Achterschouder activeren.", "60 sec"),
  ],
};

const vt_upperC_beginner = {
  id: "C", naam: "Sessie C – Upper Body",
  exercises: [
    b("A1", "Dumbbell Bench Press",              "Grotere bewegingsuitslag dan barbell. Dumbbells vlak naast de borst op het laagste punt.", "90 sec"),
    b("A2", "Barbell Row",                       "Romp 45° voorover. Trek de stang naar de navel. Ellebogen langs het lichaam.", "90 sec"),
    b("A3", "Machine Chest Press",               "Stoel afstellen op borsthoogte. Gecontroleerd duwen en langzaam terugkomen.", "90 sec"),
    b("A4", "Lat Pulldown (Smal Grip)",          "Smal of neutraal handvat. Trek naar de borst. Ellebogen recht omlaag.", "90 sec"),
    b("A5", "Pec Deck (Machine Fly)",            "Ellebogen op de pads, borst vooruit. Armen samentrekken en langzaam terug.", "60 sec"),
    b("A6", "Rear Delt Fly (Dumbbell)",          "Romp 90° voorover. Armen zijwaarts, ellebogen licht gebogen. Achterste schouder.", "60 sec"),
  ],
};

const vt_lower_beginner = {
  id: "B", naam: "Sessie B – Lower Body",
  exercises: [
    b("A1", "Squat (High Bar)",                  "Knieën volgen de voeten. Zak gecontroleerd tot parallel. Rug neutraal.", "90 sec"),
    b("A2", "Romanian Deadlift (Barbell)",        "Heupen naar achteren. Rek in hamstrings voelen. Rug recht gedurende de hele beweging.", "90 sec"),
    b("A3", "Leg Press",                          "Hoog voeten voor meer billen/hamstrings. Laag voeten voor meer quadriceps.", "90 sec"),
    b("A4", "Leg Curl (Liggend)",                 "Hiel naar bil. Gecontroleerd laten zakken in 2 seconden.", "90 sec"),
    b("A5", "Standing Calf Raise (Machine)",      "Volledig omhoogkomen op de bal van de voet. Langzaam zakken voor maximale rek.", "60 sec"),
    b("A6", "Crunch",                             "Handen achter het hoofd (niet trekken). Schouders van de grond. Langzaam terug.", "60 sec"),
  ],
};

const vt_lowerD_beginner = {
  id: "D", naam: "Sessie D – Lower Body",
  exercises: [
    b("A1", "Hack Squat (Machine)",               "Rug plat tegen de rugleuning. Voeten iets voor het platform voor meer quadriceps.", "90 sec"),
    b("A2", "Romanian Deadlift (Dumbbell)",        "Dumbells voor de benen. Rug recht. Heupen naar achteren. Hamstring rek.", "90 sec"),
    b("A3", "Bulgarian Split Squat",              "Achterste voet op bank. Voorste knie volgt de voet. Romp recht.", "90 sec"),
    b("A4", "Leg Curl (Zittend)",                  "Rug recht. Hiel naar beneden drukken. Andere krachtcurve dan liggend.", "90 sec"),
    b("A5", "Seated Calf Raise (Machine)",         "Pads op de knieën. Treft de soleus meer. Volledig rek onderaan.", "60 sec"),
    b("A6", "Cable Crunch",                        "Kabel boven het hoofd. Buig de romp naar beneden, niet de heupen. Navel naar beneden.", "60 sec"),
  ],
};

// ─── VETVERLIES — GEVORDERD ───────────────────────────────────────────────────

const vt_fullBodyA_gevorderd = {
  id: "A", naam: "Sessie A – Full Body",
  exercises: [
    gS("A1", "Squat (High Bar)",                 "Progressief zwaarder. Knieën volgen de voeten. Zak tot parallel.", "90 sec"),
    gS("A2", "Bench Press",                       "Schouderbladen samen. Gecontroleerd zakken in 3 seconden.", "90 sec"),
    gS("A3", "Romanian Deadlift (Barbell)",       "Heupen naar achteren. Rug recht. Maximale rek in de hamstrings onderaan.", "90 sec"),
    gS("A4", "Lat Pulldown (Breed Grip)",         "Trek naar sleutelbeenderen. Ellebogen omlaag. Schouderbladen samentrekken.", "90 sec"),
    gL("A5", "Dumbbell Curl (Staand)",            "Supineer de pols bovenin. Ellebogen gefixeerd. Gecontroleerd zakken.", "60 sec"),
    gL("A6", "Tricep Pushdown (Touw)",            "Touw uiteen trekken onderaan. Ellebogen naast het lichaam. Volledig strekken.", "60 sec"),
  ],
};

const vt_fullBodyB_gevorderd = {
  id: "B", naam: "Sessie B – Full Body",
  exercises: [
    gS("A1", "Leg Press",                         "Voeten schouderbreedte. Knieën niet volledig strekken. Gecontroleerd zakken.", "90 sec"),
    gS("A2", "Incline Dumbbell Press",            "Bank op 30°. Dumbbells starten naast de borst. Druk omhoog en iets naar elkaar.", "90 sec"),
    gS("A3", "Leg Curl (Liggend)",                "Hiel naar bil. Langzaam terug in 3 seconden. Volledige bewegingsomvang.", "90 sec"),
    gS("A4", "Seated Cable Row (Smal Grip)",      "Trek naar de navel. Schouderbladen maximaal samentrekken. Rug rechtop.", "90 sec"),
    gL("A5", "Hammer Curl",                       "Neutrale greep. Treft brachialis en biceps. Ellebogen gefixeerd langs het lichaam.", "60 sec"),
    gL("A6", "Tricep Pushdown (Rechte Stang)",    "Overhandse greep. Ellebogen stabiel. Volledig strekken aan de onderkant.", "60 sec"),
  ],
};

const vt_upper_gevorderd = {
  id: "A", naam: "Sessie A – Upper Body",
  exercises: [
    gS("A1", "Bench Press",                       "Schouderbladen samen. 3 sec neerwaartse fase. Explosief omhoog.", "90 sec"),
    gS("A2", "Lat Pulldown (Breed Grip)",         "Trek explosief omlaag, gecontroleerd omhoog. Schouderbladen omlaag en samen.", "90 sec"),
    gS("A3", "Incline Dumbbell Press",            "Bank op 30°. Focus op bovenste borst. Gecontroleerde neerwaartse fase.", "90 sec"),
    gS("A4", "Seated Cable Row (Smal Grip)",      "Trek naar navel. Schouderbladen volledig samentrekken aan het einde.", "90 sec"),
    gL("A5", "Cable Fly (Low to High)",           "Kabels laag. Beweging van onder naar boven. Constante spanning op de borst.", "60 sec"),
    gL("A6", "Face Pull",                         "Kabel ooghoogte. Ellebogen hoog. Rotatorenmanchet en achterschouder.", "60 sec"),
  ],
};

const vt_upperC_gevorderd = {
  id: "C", naam: "Sessie C – Upper Body",
  exercises: [
    gS("A1", "Dumbbell Bench Press",              "Grotere bewegingsuitslag. Dumbbells vlak naast borst op het laagste punt.", "90 sec"),
    gS("A2", "Barbell Row",                       "Romp 45° voorover. Trek naar de navel. Neerwaartse fase in 3 seconden.", "90 sec"),
    gS("A3", "Machine Chest Press",               "Stoel op borsthoogte. Gecontroleerd duwen. Langzame neerwaartse fase.", "90 sec"),
    gS("A4", "Lat Pulldown (Smal Grip)",          "Trek naar de borst. Ellebogen recht omlaag. Volledig strekken bovenaan.", "90 sec"),
    gL("A5", "Pec Deck (Machine Fly)",            "Borst vooruit. Constante spanning. Langzaam terugkomen.", "60 sec"),
    gL("A6", "Rear Delt Fly (Dumbbell)",          "Romp 90° voorover. Armen lateraal. Focus op achterschouder.", "60 sec"),
  ],
};

const vt_lower_gevorderd = {
  id: "B", naam: "Sessie B – Lower Body",
  exercises: [
    gS("A1", "Squat (High Bar)",                  "Progressief zwaarder. Knieën volgen voeten. Rug neutraal.", "90 sec"),
    gS("A2", "Romanian Deadlift (Barbell)",        "Heupen naar achteren. Maximale hamstring rek. Rug recht.", "90 sec"),
    gS("A3", "Leg Press",                          "Hoog voeten voor meer billen. Knieën niet volledig strekken bovenaan.", "90 sec"),
    gS("A4", "Leg Curl (Liggend)",                 "Hiel naar bil. 3 seconden neerwaartse fase. Volledige omvang.", "90 sec"),
    gL("A5", "Standing Calf Raise (Machine)",      "Volledig omhoogkomen. Langzaam zakken voor maximale rek in de kuit.", "60 sec"),
    gL("A6", "Cable Crunch",                        "Buig vanuit de navel naar beneden. Ellebogen richting knieën.", "60 sec"),
  ],
};

const vt_lowerD_gevorderd = {
  id: "D", naam: "Sessie D – Lower Body",
  exercises: [
    gS("A1", "Hack Squat (Machine)",               "Rug plat tegen de rugleuning. Voeten positie bepaalt spiergroep focus.", "90 sec"),
    gS("A2", "Romanian Deadlift (Dumbbell)",        "Rug recht. Heupen naar achteren. Rek in hamstrings voelen.", "90 sec"),
    gS("A3", "Bulgarian Split Squat",              "Achterste voet op bank. Zak tot voorste dij parallel. Romp recht.", "90 sec"),
    gS("A4", "Leg Curl (Zittend)",                  "Rug recht. Andere krachtcurve dan liggend. Volledige bewegingsomvang.", "90 sec"),
    gL("A5", "Seated Calf Raise (Machine)",         "Treft de soleus meer dan staand. Pads op knieën. Volledig rek onderaan.", "60 sec"),
    gL("A6", "Hanging Knee Raise",                  "Aan de rek hangen. Knieën naar borst brengen. Gecontroleerd terugzakken.", "60 sec"),
  ],
};

// ─── VETVERLIES — ADVANCED ────────────────────────────────────────────────────

const vt_fullBodyA_advanced = {
  id: "A", naam: "Sessie A – Full Body",
  exercises: [
    aS("A1", "Squat (High Bar)",                 "Maximale belasting bij goede techniek. 1 sec pauze onderaan. Explosief opstaan.", "120 sec"),
    aS("A2", "Bench Press",                       "4 sets van 6 reps. Zware belasting. 3-1-1-0 tempo. Spotter aanbevolen.", "120 sec"),
    aS("A3", "Romanian Deadlift (Barbell)",       "Zwaar gewicht. Maximale hamstring rek. Rug recht op elk moment.", "120 sec"),
    aS("A4", "Lat Pulldown (Breed Grip)",         "Explosief omlaag, gecontroleerd omhoog. Schouderbladen volledig samentrekken.", "120 sec"),
    aL("A5", "Barbell Curl",                      "Volledige bewegingsomvang. Geen slingerbeweging. Ellebogen gefixeerd.", "60 sec"),
    aL("A6", "Skull Crusher (EZ-Bar)",            "EZ-stang zakken naar het voorhoofd. Ellebogen stabiel. Pols neutraal.", "60 sec"),
  ],
};

const vt_fullBodyB_advanced = {
  id: "B", naam: "Sessie B – Full Body",
  exercises: [
    aS("A1", "Leg Press",                         "Maximale belasting. Knieën niet volledig strekken. Gecontroleerd zakken.", "120 sec"),
    aS("A2", "Incline Dumbbell Press",            "Bank op 30°. Zwaar gewicht. Dumbbells naast borst op het laagste punt.", "120 sec"),
    aS("A3", "Leg Curl (Liggend)",                "Zwaar gewicht. 3-1-1-0 tempo. Gecontroleerd zakken in 3 seconden.", "120 sec"),
    aS("A4", "Barbell Row",                       "Romp 45°. Trek naar de navel. Neerwaartse fase gecontroleerd in 3 sec.", "120 sec"),
    aL("A5", "Incline Dumbbell Curl",             "Bank 45°. Langere biceps rek door positie. Supineer bovenin.", "60 sec"),
    aL("A6", "Overhead Tricep Extension (Kabel)", "Kabel hoog. Ellebogen naast het hoofd. Volle extensie. Lange kop triceps.", "60 sec"),
  ],
};

const vt_upper_advanced = {
  id: "A", naam: "Sessie A – Upper Body",
  exercises: [
    aS("A1", "Bench Press",                       "Maximale belasting. Explosief omhoog. 3-1-1-0 tempo. Spotter aanbevolen.", "120 sec"),
    aS("A2", "Barbell Row",                       "Zwaar gewicht. Trek naar navel. Schouderbladen maximaal naar achteren.", "120 sec"),
    aS("A3", "Incline Dumbbell Press",            "Bank 30°. Zwaar maar gecontroleerd. Neerwaartse fase in 3 seconden.", "120 sec"),
    aS("A4", "Lat Pulldown (Smal Grip)",          "Trek explosief naar borst. Ellebogen recht omlaag. Schouderbladen omlaag.", "120 sec"),
    aL("A5", "Cable Fly (Low to High)",           "Kabels laag. Constante spanning. Armen in boogbeweging naar boven en samen.", "60 sec"),
    aL("A6", "Face Pull",                         "Kabel ooghoogte. Ellebogen hoog. Rotatorenmanchet en achterschouder.", "60 sec"),
  ],
};

const vt_upperC_advanced = {
  id: "C", naam: "Sessie C – Upper Body",
  exercises: [
    aS("A1", "Dumbbell Bench Press",              "Grotere bewegingsuitslag. Dumbbells vlak naast borst. Explosief omhoog.", "120 sec"),
    aS("A2", "Seated Cable Row (Breed Grip)",     "Breed handvat. Trek naar borst. Meer focus op bovenrug en achterschouders.", "120 sec"),
    aS("A3", "Machine Chest Press",               "Zwaar gewicht op machine. Gecontroleerd en technisch. Langzame neerwaartse fase.", "120 sec"),
    aS("A4", "Lat Pulldown (Breed Grip)",         "Trek naar sleutelbeenderen. Schouderbladen samen en omlaag.", "120 sec"),
    aL("A5", "Pec Deck (Machine Fly)",            "Constante spanning. Borst samentrekken. Langzaam terugkomen.", "60 sec"),
    aL("A6", "Rear Delt Fly (Machine)",           "Pec Deck omgekeerd. Armen naar achteren. Achterschouder isoleren.", "60 sec"),
  ],
};

const vt_lower_advanced = {
  id: "B", naam: "Sessie B – Lower Body",
  exercises: [
    aS("A1", "Squat (High Bar)",                  "Maximale belasting. 1 sec pauze onderaan. 3-1-1-0 tempo.", "120 sec"),
    aS("A2", "Romanian Deadlift (Barbell)",        "Zwaar gewicht. Maximale hamstring rek. Rug recht.", "120 sec"),
    aS("A3", "Hack Squat (Machine)",               "Zware belasting op machine. Rug plat. Voeten positie aanpassen voor focus.", "120 sec"),
    aS("A4", "Leg Curl (Liggend)",                 "Zwaar gewicht. 3-1-1-0 tempo. Maximale hiel-naar-bil beweging.", "120 sec"),
    aL("A5", "Standing Calf Raise (Machine)",      "Volledig omhoogkomen. Langzaam zakken. 12 reps met pauze bovenaan.", "60 sec"),
    aL("A6", "Cable Crunch",                        "Zware kabel. Crunch vanuit navel. Ellebogen richting knieën.", "60 sec"),
  ],
};

const vt_lowerD_advanced = {
  id: "D", naam: "Sessie D – Lower Body",
  exercises: [
    aS("A1", "Bulgarian Split Squat",             "Achterste voet op bank. Maximale depth. Romp recht. Zwaar gewicht.", "120 sec"),
    aS("A2", "Romanian Deadlift (Dumbbell)",       "Rug recht. Heupen naar achteren. Rek in hamstrings op elk moment.", "120 sec"),
    aS("A3", "Leg Press",                          "Zwaar. Hoog voeten voor meer billen. Knieën niet volledig strekken.", "120 sec"),
    aS("A4", "Nordic Hamstring Curl",              "Enkels vastgezet. Val langzaam voorover. Hamstrings remmen de val. Intensief.", "120 sec"),
    aL("A5", "Seated Calf Raise (Machine)",        "Treft soleus. Pads op knieën. Volledig rek en samentrekking.", "60 sec"),
    aL("A6", "Hanging Leg Raise",                  "Gestrekte benen naar de rek brengen. Gecontroleerd terugzakken. Core.", "60 sec"),
  ],
};

// ─── WEEKSTRUCTUUR BESCHRIJVINGEN ─────────────────────────────────────────────
const W2 = "Maandag: Sessie A (Full Body)  |  Donderdag: Sessie B (Full Body)";
const W3 = "Maandag: Sessie A (Upper Body)  |  Woensdag: Sessie B (Full Body)  |  Vrijdag: Sessie C (Lower Body)";
const W4 = "Maandag: Sessie A (Upper Body)  |  Dinsdag: Sessie B (Lower Body)  |  Donderdag: Sessie C (Upper Body)  |  Vrijdag: Sessie D (Lower Body)";

const NOTE2 = "Houd minimaal 48 uur rust tussen de trainingen. Focus op techniek voor je het gewicht verhoogt.";
const NOTE3 = "Zorg voor minimaal 1 rustdag tussen iedere training. De Upper/Lower structuur zorgt voor optimaal herstel per spiergroep.";
const NOTE4 = "4 trainingsdagen per week vereist goede herstelstrategie: 7–9 uur slaap, voldoende eiwitinname (1.8–2g/kg) en hydratatie.";

// ─── SCHEMA DEFINITIES ────────────────────────────────────────────────────────
export const FITSMITH_SCHEMAS = {

  // ── VETVERLIES BEGINNER ──────────────────────────────────────────────────────
  "vetverlies-beginner-2x": {
    meta: { doel: "Vetverlies", sub_doel: "met behoud van spiermassa", niveau: "Beginner", frequentie: "2x per week", schema_naam: "Vetverlies Beginner – 2x per week", weekstructuur: W2, notitie: NOTE2 },
    sessions: [vt_fullBodyA_beginner, vt_fullBodyB_beginner],
  },
  "vetverlies-beginner-3x": {
    meta: { doel: "Vetverlies", sub_doel: "met behoud van spiermassa", niveau: "Beginner", frequentie: "3x per week", schema_naam: "Vetverlies Beginner – 3x per week", weekstructuur: W3, notitie: NOTE3 },
    sessions: [
      { ...vt_upper_beginner, id: "A", naam: "Sessie A – Upper Body" },
      { ...vt_fullBodyB_beginner, id: "B", naam: "Sessie B – Full Body" },
      { ...vt_lower_beginner, id: "C", naam: "Sessie C – Lower Body" },
    ],
  },
  "vetverlies-beginner-4x": {
    meta: { doel: "Vetverlies", sub_doel: "met behoud van spiermassa", niveau: "Beginner", frequentie: "4x per week", schema_naam: "Vetverlies Beginner – 4x per week", weekstructuur: W4, notitie: NOTE4 },
    sessions: [
      { ...vt_upper_beginner, id: "A", naam: "Sessie A – Upper Body" },
      { ...vt_lower_beginner, id: "B", naam: "Sessie B – Lower Body" },
      { ...vt_upperC_beginner },
      { ...vt_lowerD_beginner },
    ],
  },

  // ── VETVERLIES GEVORDERD ─────────────────────────────────────────────────────
  "vetverlies-gevorderd-2x": {
    meta: { doel: "Vetverlies", sub_doel: "met behoud van spiermassa", niveau: "Gevorderd", frequentie: "2x per week", schema_naam: "Vetverlies Gevorderd – 2x per week", weekstructuur: W2, notitie: NOTE2 },
    sessions: [vt_fullBodyA_gevorderd, vt_fullBodyB_gevorderd],
  },
  "vetverlies-gevorderd-3x": {
    meta: { doel: "Vetverlies", sub_doel: "met behoud van spiermassa", niveau: "Gevorderd", frequentie: "3x per week", schema_naam: "Vetverlies Gevorderd – 3x per week", weekstructuur: W3, notitie: NOTE3 },
    sessions: [
      { ...vt_upper_gevorderd, id: "A", naam: "Sessie A – Upper Body" },
      { ...vt_fullBodyB_gevorderd, id: "B", naam: "Sessie B – Full Body" },
      { ...vt_lower_gevorderd, id: "C", naam: "Sessie C – Lower Body" },
    ],
  },
  "vetverlies-gevorderd-4x": {
    meta: { doel: "Vetverlies", sub_doel: "met behoud van spiermassa", niveau: "Gevorderd", frequentie: "4x per week", schema_naam: "Vetverlies Gevorderd – 4x per week", weekstructuur: W4, notitie: NOTE4 },
    sessions: [
      { ...vt_upper_gevorderd, id: "A", naam: "Sessie A – Upper Body" },
      { ...vt_lower_gevorderd, id: "B", naam: "Sessie B – Lower Body" },
      { ...vt_upperC_gevorderd },
      { ...vt_lowerD_gevorderd },
    ],
  },

  // ── VETVERLIES ADVANCED ──────────────────────────────────────────────────────
  "vetverlies-advanced-2x": {
    meta: { doel: "Vetverlies", sub_doel: "met behoud van spiermassa", niveau: "Advanced", frequentie: "2x per week", schema_naam: "Vetverlies Advanced – 2x per week", weekstructuur: W2, notitie: NOTE2 },
    sessions: [vt_fullBodyA_advanced, vt_fullBodyB_advanced],
  },
  "vetverlies-advanced-3x": {
    meta: { doel: "Vetverlies", sub_doel: "met behoud van spiermassa", niveau: "Advanced", frequentie: "3x per week", schema_naam: "Vetverlies Advanced – 3x per week", weekstructuur: W3, notitie: NOTE3 },
    sessions: [
      { ...vt_upper_advanced, id: "A", naam: "Sessie A – Upper Body" },
      { ...vt_fullBodyB_advanced, id: "B", naam: "Sessie B – Full Body" },
      { ...vt_lower_advanced, id: "C", naam: "Sessie C – Lower Body" },
    ],
  },
  "vetverlies-advanced-4x": {
    meta: { doel: "Vetverlies", sub_doel: "met behoud van spiermassa", niveau: "Advanced", frequentie: "4x per week", schema_naam: "Vetverlies Advanced – 4x per week", weekstructuur: W4, notitie: NOTE4 },
    sessions: [
      { ...vt_upper_advanced, id: "A", naam: "Sessie A – Upper Body" },
      { ...vt_lower_advanced, id: "B", naam: "Sessie B – Lower Body" },
      { ...vt_upperC_advanced },
      { ...vt_lowerD_advanced },
    ],
  },

  ...SPIEROPBOUW_SCHEMAS,
  ...ONDERHOUD_SCHEMAS,
  ...POWERLIFTING_SCHEMAS,
};

export function getSchema(comboKey) {
  return FITSMITH_SCHEMAS[comboKey] || null;
}

export const SCHEMA_KEYS = Object.keys(FITSMITH_SCHEMAS);
